<template>
  <section>
    <div class="authors">
      <h2
        class="how__title content__title content__title--contrast content__title--small authors__title"
        style="text-transform:none"
      >
        Swoje przepisy na lepszą Polskę dali nam:
      </h2>
        <div class="authors__wrapper">
          
              <div class="authors__names">
                <div class="authors__box" v-for="item in authors" :key="item.name">
                  <div class="authors__name">{{ item.name }}</div>
                  <div class="authors__desc">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
              <SliderFrag />
        </div>

    </div>

    <div class="authors__slider">
      <vueper-slides
        autoplay
        :fixed-height="true"
        class="no-shadow"
        :visible-slides="1"
        slide-multiple
        :arrows-outside="false"
        :bullets="true"
        :infinite="true"
        :dragging-distance="100"
        :touchable="true"
        :disable-arrows-on-edges="true"
      >
    
        <vueper-slide v-for="item in authors" :key="item.desc">
      
          <template #content>
            <div class="authors__boxslide">
              <div class="authors__nameslide">{{ item.name }}</div>
              <div class="authors__descslide">
                {{ item.desc }}
              </div>
            </div>
          </template>
        </vueper-slide>
            <template #arrow-left>
          <img src="@/assets/images/icons/prev.png">
        </template>

        <template #arrow-right>
          <img src="@/assets/images/icons/next.png">
        </template>
      </vueper-slides>
    </div>
  </section>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import SliderFrag from "@/components/elements/SliderFragm";
export default {
  name: "Authors",
  components: { VueperSlides, VueperSlide, SliderFrag },
  inject: ["content"],
  data() {
    return {
      authors: [
        {
          name: "dr Tomasz Markiewka",
          desc:
            "Filozof. Wykłada na Uniwersytecie Mikołaja Kopernika w Toruniu. Autor książek „Język neoliberalizmu”, „Gniew”, „Zmienić świat raz jeszcze. Jak wygrać walkę o klimat”.",
        },
        {
          name: "Ane Piżl",
          desc:
            "Prowadzi profil edukacyjny @ane_ratownica, w którym porusza temat języka inkluzywnego. Członkini Towarzystwa Edukacji Antydyskryminacyjnej oraz sieci edukatorów i edukatorek Amnesty International. Od lat działa na rzecz równości i edukacji medycznej. ",
        },
        {
          name: "Jarosław Niemiec",
          desc:
            "Elektromonter w Zakładzie Przeróbki Mechanicznej Węgla LW Bogdanka, działacz społeczny i związkowy, obecnie przewodniczący Zarządu Zakładowego Związku Zawodowego „Przeróbka”.",
        },
        {
          name: "dr Jakub Rok",
          desc:
            "Pracownik naukowy UW, doktor ekonomii zainteresowany jej związkami z naturą. Lubi dzikie lasy i stara się je chronić – z Obozem dla Puszczy (Białowieskiej) i Inicjatywą Dzikie Karpaty. Najbardziej chciałby zatrzymać walec utowarowienia ludzi i przyrody.",
        },
        {
          name: "Jan Zygmuntowski",
          desc:
            "Ekonomista, dyrektor programowy CoopTech Hub, pierwszego w Polsce centrum technologii spółdzielczych. Współprzewodniczący Polskiej Sieci Ekonomii. Założyciel i w latach 2015-2020 prezes zarządu think-tanku Instrat. Autor „Kapitalizmu sieci”.",
        },
        {
          name: "Joanna Erbel",
          desc:
            "Socjolożka i ekspertka ds. mieszkaniowych. Koordynowała prace nad projektem polityki mieszkaniowej m.st. Warszawy. Współpracowniczka Fundacji A/typowi, działającej na rzecz neuroróżnorodności. Autorka książek.",
        },
        {
          name: "Maciej Mandelt",
          desc:
            "Aktywista, współtworzy Stowarzyszenie Nomada, które wspiera osoby z doświadczeniem migracji. Działa w Grupie Granica – ruchu, który odpowiada na kryzys humanitarny na granicy polsko-białoruskiej i reaguje na naruszenia praw osób uchodźczych w Polsce.",
        },
        {
          name: "prof. dr hab. Ewa Bińczyk",
          desc:
            "Filozofka, profesora na Wydziale Filozofii i Nauk Społecznych UMK. Zajmuje się m.in. filozofią środowiskową i założeniami filozoficznymi ekonomii ekologicznej dewzrostu. Autorka m.in. książki „Epoka człowieka. Retoryka i marazm antropocenu”",
        },
        {
          name: "dr hab. Paulina Kramarz, prof. UJ",
          desc:
            "Ekolożka, profesora w Instytucie Nauk o Środowisku UJ. Współpracuje z organizacjami pozarządowymi oraz ruchami oddolnymi. Współtworzyła portal Nauka dla Przyrody. Jest współautorką Narodowej Strategii Ochrony Owadów Zapylających.",
        },
        {
          name: "dr hab. Agnieszka Graff",
          desc:
            "Feministka, kulturoznawczyni, profesorka w Ośrodku Studiów Amerykańskich UW, badaczka feminizmu i ruchów anty-gender. Współtwórczyni pierwszych Manif, uczestniczka Kongresu Kobiet od początku jego istnienia. Felietonistka i autorka książek.",
        },
        {
          name: "Oliwia Bosomtwe",
          desc:
            'Redaktorka naczelna Noizz.pl, wcześniej związana z magazynami „Wysokie Obcasy Praca" i „Res Publica Nowa". Autorka tekstów naukowych, przez kilka lat zajmująca się digitalizacją w instytucjach kultury. Należy do rady fundacji Inspiring Girls Polska.',
        },
        {
          name: "Bart Staszewski",
          desc:
            "Aktywista i reżyser filmów dokumentalnych, m.in. „Artykuł osiemnasty” o walce o prawo do małżeństw jednopłciowych. Współzałożyciel fundacji Basta monitorującej homofobiczną nienawiść w mediach. Twórca akcji fotograficznej „Strefa wolna od LGBT”.",
        },
        {
          name: "dr Weronika Parfianowicz",
          desc:
            "Kulturoznawczyni, pracuje w Instytucie Kultury Polskiej UW. Zajmuje się m.in. politykami mieszkaniowymi, ideami ekosocjalizmu i postwzrostu. Członkini związku zawodowego Inicjatywa Pracownicza.",
        },
        {
          name: "Wojtek Sawicki",
          desc:
            "Influencer z misją, wraz z żoną prowadzi profil @LifeOnWheelz, na którym walczy z dyskryminacją osób z niepełnosprawnościami. Chory na dystrofię mięśniową Duchenne’a. Były redaktor naczelny portalu Porcys, obecnie prowadzi listę przebojów Carpigiani. Obsługuje komputer za pomocą wzroku.",
        },
        {
          name: "Marcel Andino Velez",
          desc:
            "Opiekun medyczny. Pracuje jako tzw. Młodszy Brat, czyli rodzinny koordynator opieki geriatrycznej. Pracował jako dziennikarz „Przekroju”, a także jako wicedyrektor Muzeum Sztuki Nowoczesnej w Warszawie. Autor powieści „Świeccy”.",
        },
        {
          name: "Lu Gaszyński",
          desc:
            "Aktywista i fundraiser Greenpeace od 2018 roku. Poza aktywizmem ulicznym, zajmuje się też tym internetowym, prowadząc profil @wstyduniemasz. Oddany walce o prawa osób queerowych i z zaburzeniami zdrowia psychicznego.",
        },
        {
          name: "Jana Shostak",
          desc:
            "Polsko-białoruska aktywistka i artystka. Zaproponowała wprowadzenie słowa „nowak” (homonim jednego z najpopularniejszych w Polsce nazwisk) jako słowa zamiennego do określenia „uchodźca“. Zorganizowała akcję „Minuta krzyku dla Białorusi”.",
        },
        {
          name: "Janina Bąk",
          desc:
            "Znana jako Janina Daily. Blogerka, statystyczka, nauczycielka akademicka. Nominowana w Plebiscycie Korony Równości organizowanym przez Kampanię Przeciw Homofobii w kategorii ludzie internetu. Normalizuje temat problemów psychicznych",
        },
        {
          name: "Paulina Bownik",
          desc:
            "Lekarka z Grupy Granica, mieszka na Podlasiu. Ratuje uchodźców w lasach na granicy polsko-białoruskiej. Uhonorowana Nagrodą im. Doktora Marka Edelmana „za ratowanie człowieczeństwa”.",
        },
      ],
    };
  },
};
</script>
